module.exports = __webpack_public_path__ + "static/media/pencil.4c53eea5.svg";